import NewDeploymentConfiguration from './create/components/NewDeploymentConfiguration';

const NewDeploymentView = () => <NewDeploymentConfiguration />;

export default NewDeploymentView;
